//

import { Form } from 'react-hook-form'
import { FixedTable, FormTable } from './formComponents'
import { ObjectContext } from '../../Components/OCV/OCVTypes'

export const LeftTables = (props: {
    leftTableList: any[]
    setDialogObject: (a: ObjectContext) => void
    setDialogVisible: (a: boolean) => void
}) => {
    const { leftTableList, setDialogObject, setDialogVisible } = props
    return (
        <div id="left_tables" className="scroll-container scroll-fade">
            {leftTableList.map((table, index) => {
                const title = table.objectData.item0[table.j_index]?.t ?? ''
                const component = table.lauoutObj.component
                if (table.fixed) {
                    return (
                        <FixedTable
                            key={index}
                            render="left"
                            component={component}
                            title={title}
                            j_index={table.j_index}
                            index={index}
                            setDialogObject={setDialogObject}
                            setDialogVisible={setDialogVisible}
                        />
                    )
                } else {
                    return (
                        <FormTable
                            key={index}
                            render="left"
                            component={component}
                            title={title}
                            collapsed={table.collapsed}
                            j_index={table.j_index}
                            index={index}
                            setDialogObject={setDialogObject}
                            setDialogVisible={setDialogVisible}
                        />
                    )
                }
            })}
        </div>
    )
}
